export default function(obj) {
  return encodeURIComponent(JSON.stringify(obj));
}
